import React, { createContext, useContext, useState, useEffect } from 'react';
import { loginUser } from '../api/authApi';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [role, setRole] = useState(localStorage.getItem('role'));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
  const [loading, setLoading] = useState(true);
  const isPaymentEnabled = false; // Temporary flag to disable payment features

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');

    if (storedToken && storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setToken(storedToken);
        setUser(parsedUser);
        setRole(parsedUser.role);
      } catch (error) {
        console.error("Failed to parse user from localStorage in useEffect", error);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('role');
        setToken(null);
        setUser(null);
        setRole(null);
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const data = await loginUser(username, password);
    if (data.access_token) {
      const decodedToken = JSON.parse(atob(data.access_token.split('.')[1]));
      const currentUser = {
          username: decodedToken.sub,
          role: decodedToken.role
      };
      setToken(data.access_token);
      setRole(currentUser.role);
      setUser(currentUser);
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('user', JSON.stringify(currentUser));
      return currentUser.role;
    }
    return null;
  };

  const logout = () => {
    setToken(null);
    setRole(null);
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('user');
  };

  const updateUser = (userData) => {
    const updatedUser = { ...user, ...userData };
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
    if (userData.role) {
      setRole(userData.role);
      localStorage.setItem('role', userData.role);
    }
  };

  return (
    <AuthContext.Provider value={{ 
      token, 
      role, 
      user, 
      loading,
      isPaymentEnabled,
      login,
      logout,
      updateUser
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}; 